femcare.audioPlatform.soundcloud = {

    init: function () {
        var $podcasts = $('.podcast-embed--soundcloud');

        if ($podcasts.length) {

            $podcasts.each(function (index, element) {
                var $container = $(element);
                var source = $container.attr('data-soundcloud-source');
                var maxHeight = 166;
                var url = 'https://soundcloud.com/oembed?url=' + encodeURIComponent(source) + '&maxheight=' + maxHeight;

                $.get(url).done(function (data) {
                    // Request 'classic' embed skin, not the enhanced 'visual' one
                    $container.html(data.html.replace('visual=true', 'visual=false'));
                });

            });
        }
    }
};
